import { Navigate } from 'react-router';
import { useParam } from '@gonfalon/router/useParam';

/**
 * Redirects for the product analytics chart routes for backward compatibility
 * Handles redirects from old visualization URLs to new chart URLs
 */
export function PaVisualizationRedirect({ target }: { target?: string }) {
  const projectKey = useParam('projectKey');
  const id = useParam('id', { optional: true });

  const path = target === 'id' ? id : 'new';
  return <Navigate to={`/projects/${projectKey}/product-analytics/charts/${path}`} replace />;
}
